import React, { useState } from 'react';

function ConfirmModal({ confirmFn, text, buttonText }) {
  const [isChecked, setIsChecked] = useState(false);

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };

  return (
    <div className="static-modal">
      <div className="modal fade" id="modal-danger">
        <div className="modal-dialog d-flex align-items-center" style={{ height: "calc(100vh - 72px)" }}>
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Confirm Action</h4>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <p style={{marginBottom:'10px'}}>{text}</p>
              <div className="form-check">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="confirmCheckbox"
                  checked={isChecked}
                  onChange={handleCheckboxChange}
                />
                <label className="form-check-label" htmlFor="confirmCheckbox">
                Yes, I want to delete
                </label>
              </div>
            </div>
            <div className="modal-footer justify-content-end">
              <button type="button" className="btn btn-default" data-dismiss="modal">
                Close
              </button>
              <button
                type="button"
                className="btn btn-danger"
                onClick={confirmFn}
                data-dismiss="modal"
                disabled={!isChecked}
              >
                {buttonText || 'Confirm'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ConfirmModal;
